<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-4 col-lg-4">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialpesq2" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfilial">
                                </select>
                            </div> 
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lsttemplates"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <div class="d-flex">
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                            <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                            <button type="button" class="btn btn-primary btn-sm btn-opcrud" @click.prevent="mtdexportartemplate(item.row)" title="Exportar template"><i class="fa fa-share-square-o" aria-hidden="true"></i></button>
                                        </div>
                                    </template>
                                    <template slot="categoria_slot" slot-scope="item">
                                        <span v-if="item.row.categoria == '0'">Whatsapp</span>
                                        <span v-else-if="item.row.categoria == '1'">E-mail</span>
                                    </template>
                                    <template slot="tpmensagem_slot" slot-scope="item">
                                        <span v-if="item.row.tpmensagem == '0'">COBRANÇA INDIVIDUAL DE TÍTULO</span>
                                        <span v-else-if="item.row.tpmensagem == '1'">COBRANÇA MÚLTIPLA DE TÍTULOS</span>
                                        <span v-else-if="item.row.tpmensagem == '2'">LEMBRETE DE CASHBACK</span>
                                        <span v-else-if="item.row.tpmensagem == '3'">MENSAGEM DE ANIVERSÁRIO</span>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lsttemplates.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-10">
                                <div class="row">
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edid">Código:</label>
                                        <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                               maxlength="20" disabled/>
                                    </div>
                                    <div class="col-sm-12 col-md-7 col-lg-7">
                                        <label for="eddescricao">*Descrição:</label>
                                        <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                               class="form-control form-control-sm" id="eddescricao" maxlength="50">
                                    </div>
                                    <div class="col-sm-12 col-md-3 col-lg-3">
                                        <span class="lblselect2">*Filial:</span>
                                        <select id="cbfilialpesq" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                style="width:100%;" v-model="vidfilial">
                                        </select>
                                    </div>  
                                </div>
                                <div class="row mt-3">
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edcategoria">Categoria:</label>
                                        <select name="cbcategoria" class="form-control form-control-sm" id="cbcategoria" v-model="vcategoria"  v-bind:disabled="ativadesativa" @change="mtdlimpar_listagem()">
                                            <option value="0">Whatsapp</option>
                                            <option value="1">E-mail</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="edidtemplate">ID template:</label>
                                        <input type="text" v-model="vidtemplate" v-bind:disabled="ativadesativa"
                                               class="form-control form-control-sm" id="edidtemplate" maxlength="512">
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <label for="edtipomensagem">Tipo de mensagem:</label>
                                        <select name="edtipomensagem" class="form-control form-control-sm" id="edtipomensagem" v-model="vtipomensagem"  v-bind:disabled="ativadesativa" @change="mtdlimpar_listagem()">
                                            <option value="0">COBRANÇA INDIVIDUAL DE TÍTULO</option>
                                            <option value="1">COBRANÇA MÚLTIPLA DE TÍTULOS</option>
                                            <option value="2">LEMBRETE DE CASHBACK</option>
                                            <option value="3">MENSAGEM DE ANIVERSÁRIO</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <button class="btn btn-primary btn-preview-msg" type="button" data-toggle="collapse" data-target="#collapsePreviewTemplate" aria-expanded="false" aria-controls="collapsePreviewTemplate">
                                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Personalizar mensagem
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2 card ct-selecaoimagem">
                                <label for="ipmidia">Mídia:</label>
                                <input
                                    type="file" 
                                    id="ipmidia"
                                    accept="image/png, image/jpeg" 
                                    @change="mtdselecionarimagem($event)" 
                                    style="display: none;"
                                    ref="click_midia">
                                <div v-if="midiaName" class="imagem-selecionada">
                                    <img :src="'https://'+$store.state.usuario.adrsrv+'/arquivos/manager/templatesmensagens/'+$store.state.usuario.idclientesac+'/'+pathimagens+'/'+midiaName" alt="" style="width: 100%;">
                                    <div class="container-remover-imagem">
                                        <button @click.prevent="mtdconfirmaremoverimagem()"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                                <div v-else class="selecionar-imagem" @click="$refs.click_midia.click()">
                                    <i class="fa fa-upload" aria-hidden="true"></i>
                                    <span>Selecionar Imagem</span>
                                </div>
                            </div>
                        </div>
                        <div class="row collapse mt-3" id="collapsePreviewTemplate">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <div class="card">
                                    <div class="card-header bg-primary text-white">
                                        <strong>Variáveis disponíveis</strong>
                                    </div>
                                    <div class="card-body">
                                        <p>Você pode usar as variáveis abaixo no corpo da mensagem para personaliza-la:</p>
                                        <table class="table table-bordered table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Descrição</th>
                                                    <th>Variável</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Nome do cliente</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@nomecliente@@</span></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Documento do cliente</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@cnpjcpfcliente@@</span></td>
                                                </tr>
                                                <tr >
                                                    <td><strong>Data de aniversário cliente</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@dtaniversariocli@@</span></td>
                                                </tr>
                                                <tr v-show="vtipomensagem == '0'">
                                                    <td><strong>Data de emissão do título</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@dtemissaotit@@</span></td>
                                                </tr>
                                                <tr v-show="vtipomensagem == '0'">
                                                    <td><strong>Data de vencimento do título</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@dtvencimentotit@@</span></td>
                                                </tr>
                                                <tr v-show="vtipomensagem == '0'">
                                                    <td><strong>Valor do título</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@vlpendentetit@@</span></td>
                                                </tr>
                                                <tr v-show="vtipomensagem == '0'">
                                                    <td><strong>Código do título</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@codigotitulo@@</span></td>
                                                </tr>
                                                <tr v-show="vtipomensagem == '0'">
                                                    <td><strong>Link do rillpay</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@linkrillpay@@</span></td>
                                                </tr>
                                                <tr v-show="vtipomensagem == '1'">
                                                    <td><strong>Lista de títulos</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@listatitulos@@</span></td>
                                                </tr>
                                                <tr v-show="vtipomensagem == '1'">
                                                    <td><strong>Valor total dos títulos</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@vltotaltitulos@@</span></td>
                                                </tr>
                                                <tr v-show="vtipomensagem == '1'">
                                                    <td><strong>Link do rillpay</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@linkrillpay@@</span></td>
                                                </tr>

                                                <tr v-show="vtipomensagem == '2'">
                                                    <td><strong>Cashback adquirido</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@cashadiquirido@@</span></td>
                                                </tr>

                                                <tr v-show="vtipomensagem == '2'">
                                                    <td><strong>Cashback disponivel</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@cashdisponivel@@</span></td>
                                                </tr>

                                                <tr v-show="vtipomensagem == '2'">
                                                    <td><strong>Validade cashback</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@validadecash@@</span></td>
                                                </tr>


                                                <tr>
                                                    <td><strong>Data e hora do envio da mensagem</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@datahoradisparo@@</span></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Telefone da filial</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@telefonefil@@</span></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Nome da filial</strong></td>
                                                    <td><span style="color: red; font-weight: 600;">@@nomefil@@</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="card mt-3">
                                            <div class="card-body">
                                                <p class="mb-2"><strong>Exemplo de Mensagem:</strong></p>
                                                <p class="bg-light p-3 rounded text-dark">
                                                    Prezado, <span style="color: red; font-weight: 600;">@@nomecliente@@</span>! Espero que esteja bem.<br>
                                                    Estou entrando em contato para lembrá-lo que o título <span style="color: red; font-weight: 600;">@@codigotitulo@@</span> 
                                                    no valor de R$<span style="color: red; font-weight: 600;">@@vlpendentetit@@</span> vence em 
                                                    <span style="color: red; font-weight: 600;">@@dtvencimentotit@@</span>.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div class="form-group">
                                    <!-- <label for="edtextomsg" class="font-weight-bold">*Corpo da mensagem:</label> -->
                                    <textarea 
                                        id="edtextomsg" 
                                        v-model="vtextomsg" 
                                        v-bind:disabled="ativadesativa" 
                                        class="form-control form-control-sm shadow-sm txtarea-preview-msg" 
                                        maxlength="1024" 
                                        >
                                    </textarea>
                                    <small class="form-text text-muted mt-1">
                                        Insira a mensagem que será utilizada. Máximo de 1024 caracteres.
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                                    <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modalMensagemWhatsapp" tabindex="-1" role="dialog" aria-labelledby="modalMensagemWhatsappLabel" aria-hidden="true">
            <!-- exibir imagem se urlMidiaModal for diferente de null -->
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalMensagemWhatsappLabel">Template formatado whatsapp</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- Textarea para visualizar e copiar a mensagem formatada -->
                        <textarea 
                            v-model="textomsgformatada" 
                            class="form-control"
                            style="width: 100%; min-height: 50vh;"
                            readonly
                        ></textarea>
                        <div v-if="urlMidiaModal" class="text-center mt-2">
                            <img :src="'https://'+urlMidiaModal" alt="Mídia do template" style="max-width: 100%; max-height: 200px; border: 1px solid #ddd; border-radius: 4px; padding: 5px;">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        <modal name="modalCropImage" height="auto">
            <div class="container-cropper card">
                <div class="card-header titulo-cropper">
                    <h4>Recorte da imagem</h4>
                    <p><i class="fa fa-object-group" aria-hidden="true"></i> {{ tituloCropper }}</p>
                </div>
                <div class="card-body body-cropper">
                    <cropper
                        ref="cropper"
                        :src="imgselecionada"
                        :stencil-props="{
                            aspectRatio: aspectRatioCropper,
                            scalable: scalableCropper,
                        }"
                    />
                </div>
                <div class="card-footer">
                    <small>Proporção da imagem:</small>
                    <div class="aspectRatios">
                        <button @click="mtdalteraproporcaocropper('livre')" class="btn-aspectratio">Livre</button>
                        <button @click="mtdalteraproporcaocropper('1:1')" class="btn-aspectratio"><div class="p1-1"></div><small>1:1</small></button>
                        <button @click="mtdalteraproporcaocropper('27:9')" class="btn-aspectratio"><div class="p27-9"></div><small>27:9</small></button>
                        <button @click="mtdalteraproporcaocropper('25:9')" class="btn-aspectratio"><div class="p25-9"></div><small>25:9</small></button>
                        <button @click="mtdalteraproporcaocropper('23:9')" class="btn-aspectratio"><div class="p23-9"></div><small>23:9</small></button>
                        <button @click="mtdalteraproporcaocropper('16:9')" class="btn-aspectratio"><div class="p16-9"></div><small>16:9</small></button>
                    </div>
                    <div class="btns-cropper">
                        <button @click.prevent="mtdcancelaselecaoimagem()" class="btn btn-secondary">Cancelar</button>
                        <button @click.prevent="mtdconfirmaimagemcortada()" class="btn btn-primary">Salvar Alterações</button>
                    </div>    
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'
    import imageCompression from 'browser-image-compression';

    export default {
        name: 'cadtemplatesmensagens',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                imgselecionada              : null,
                extimgselecionada           : null,
                imgparaupload               : null,
                tituloCropper               : 'Livre',
                aspectRatioCropper          : null,
                scalableCropper             : false,
                pathimagens                 : null,
                midiaName                   : null,
                urlMidiaModal               : null,
                
                lsttemplates  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vtextomsg           : '',
                textomsgformatada   : '',
                vdescricao          : '',
                vcategoria          : '0',
                vidtemplate         : '',
                vtipomensagem       : '0',
                vidfilial           : null,
                pidfilial           : null,

                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                //variável para habilitação dos campos
                ativadesativa       : true,

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'TEMPLATES',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Categoria",
                        name: "categoria",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "categoria_slot",
                    },
                    {
                        label: "Tp. Mensagem",
                        name: "tpmensagem",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "tpmensagem_slot",
                    },
                    {
                        label: "Filial",
                        name: "descfil",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(descricao) like upper("'+this.pconteudo+'%")';
                }

                if(this.pidfilial !== null) {                    
                    // feito na correria :( - Rodrigo 23/09/25
                    rfiltro = rfiltro + ' and tbtemplatesmensagens.idfilial=' + this.pidfilial;
                }
                return rfiltro;
            },
            mtdselect2_def(){
                let vself = this;
                let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';  
				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});
				$("#cbfilialpesq2").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq2").val();
					vself.mtdlimpar_listagem();
				});
            },
            mtdexecutapesquisa(){
                var vself           = this;
                if (parseInt(vself.utodasfiliais) == 0){
                    if (vself.pidfilial === null || vself.pidfilial === ''){
                        vself.$toastr.i('Para o seu usuário, é necessário selecionar uma filial!', 'Atenção!');
                        $('#cbfilialpesq2').focus();
                        return;
                    }
                }
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtemplatesmensagens.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregatemplates(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregatemplates(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtemplatesmensagens.php');
                retorno.then(function (response) {
                    vself.lsttemplates = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lsttemplates = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vid                =  '';
                this.vdescricao         =  '';
                this.vcategoria         = '0';
                this.vtextomsg          =  '';
                this.vidfilial          =  null;
                this.pidfilial          =  null;
                this.textomsgformatada  =  '';
                this.vidtemplate        =  '';
                this.vtipomensagem      = '0';
                this.pathimagens        = util.GerarStringAleatoria();
                this.midiaName          = null;

                $("#cbfilialpesq").val(null).trigger('change');
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('001Z.230Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE TEMPLATES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lsttemplates = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtemplatesmensagens.php');
                retorno.then(function (response) {
                     loader.hide();
                     vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('001Z.230Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE TEMPLATES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
;
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('001Z.230Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE TEMPLATES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                 = registro.id;
                this.vdescricao          = registro.descricao;
                this.vcategoria          = registro.categoria;
                this.vtextomsg           = registro.textomsg;
                this.vidfilial           = registro.idfilial;
                this.vidtemplate         = registro.idtemplate;
                this.vtipomensagem       = registro.tpmensagem;
                this.pathimagens         = (registro.pathimagens == '' || registro.pathimagens == null) ? util.GerarStringAleatoria() : registro.pathimagens;
                if (this.vidfilial !== null){
                    var deffil                = new Option(registro.descfil, registro.idfilial, true, true);
                    $('#cbfilialpesq').append(deffil).trigger('change');                
                }else{
                    $('#cbfilialpesq').val(null).trigger('change');
                }

                this.mtdcarregamidia();
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    id                : this.vid,
                    descricao         : this.vdescricao,
                    categoria         : this.vcategoria,
                    textomsg          : this.vtextomsg,
                    idfilial          : this.vidfilial === null ? null : this.vidfilial,
                    idtemplate        : this.vidtemplate,
                    tpmensagem        : this.vtipomensagem,
                    pathimagens       : (this.pathimagens == '' || this.pathimagens == null) ? util.GerarStringAleatoria() : this.pathimagens,
                    endservidor       : this.$store.state.usuario.adrsrv,
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.230Z.010Z' : parseInt(this.opcrud) === 2 ? '001Z.230Z.020Z' : '001Z.230Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtemplatesmensagens.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregatemplates(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdexportartemplate(item){
                let contador = 0;
                this.urlMidiaModal = null;
                this.textomsgformatada = item.textomsg.replace(/@@(.*?)@@/g, () => {
                    contador++;
                    return `{{${contador}}}`;
                });
                this.mtdcarregamidia(item.pathimagens);
                $('#modalMensagemWhatsapp').modal('show');
            },
            mtdselecionarimagem(event){
                this.extimgselecionada = util.extensaoarquivo(event.target.files[0]).toLowerCase();
                this.imgselecionada = URL.createObjectURL(event.target.files[0]);
                this.mtdalteraproporcaocropper('1:1');
                this.$modal.show('modalCropImage')
                event.target.value = null;
            },
            mtdcancelaselecaoimagem(){
                // this.opimagem = 0;
                this.imgselecionada = null;
                this.extimgselecionada = null;
                this.aspectRatioCropper = null;
                this.scalableCropper    = false;
                this.$modal.hide('modalCropImage')
            },
            mtdalteraproporcaocropper(ratio){
                this.aspectRatioCropper = null;
                switch (ratio) {
                    case '1:1':
                        this.tituloCropper      = '1:1';
                        this.aspectRatioCropper = 1;
                        this.scalableCropper    = true;
                    break;
                    case '16:9':
                        this.tituloCropper      = '16:9';
                        this.aspectRatioCropper = 16 / 9;
                        this.scalableCropper    = true;
                    break;
                    case '23:9':
                        this.tituloCropper      = '23:9';
                        this.aspectRatioCropper = 23 / 9;
                        this.scalableCropper    = true;
                    break;
                    case '25:9':
                        this.tituloCropper      = '25:9';
                        this.aspectRatioCropper = 25 / 9;
                        this.scalableCropper    = true;
                    break;
                    case '27:9':
                        this.tituloCropper      = '27:9';
                        this.aspectRatioCropper = 27 / 9;
                        this.scalableCropper    = true;
                    break;
                    default:
                        this.tituloCropper      = 'Livre';
                        this.aspectRatioCropper = null;
                        this.scalableCropper    = false;
                    break;
                }
            },
            mtdconfirmaimagemcortada(){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma o envio da imagem?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                vself.mtdsalvaimagemcortada();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                vself.mtdcancelaselecaoimagem();
                            }
                        }
                    }
                });
            },
            async mtdsalvaimagemcortada() {
                let vself = this;
                vself.pathimagens = vself.pathimagens == '' || vself.pathimagens == null ? util.GerarStringAleatoria() : vself.pathimagens;
                vself.imgparaupload = null;

                // PEGA A IMAGEM RECORTADA E CONVERTE PARA BLOB -> ARQUIVO
                const { canvas } = vself.$refs.cropper.getResult();

                const createBlob = () => {
                    return new Promise((resolve) => {
                    canvas.toBlob((blob) => {
                        resolve(blob);
                    }, `image/${vself.extimgselecionada}`);
                    });
                };

                const blob = await createBlob();

                // monta o arquivo original
                const originalFile = new File(
                    [blob],
                    `midiatemplate.${vself.extimgselecionada}`,
                    { type: `image/${vself.extimgselecionada}` }
                );

                // OPÇÕES DE COMPRESSÃO
                const options = {
                    maxSizeMB: 1,          // tamanho máximo em MB (ex.: 1MB)
                    maxWidthOrHeight: 1920, // redimensionar se maior
                    useWebWorker: true,     // processar em background
                    initialQuality: 0.7     // qualidade inicial
                };

                // COMPRIMINDO O ARQUIVO
                const compressedFile = await imageCompression(originalFile, options);

                vself.imgparaupload = compressedFile;

                // monta o caminho para salvar no servidor
                let localsalvar = 'arquivos/manager/templatesmensagens/' + vself.$store.state.filialpadrao.idcliente + '/' + vself.pathimagens;

                let loader = vself.$loading.show();
                let parametros = [
                    { parametro: 'arquivo', valor: vself.imgparaupload },
                    { parametro: 'localsalvar', valor: localsalvar },
                    { parametro: 'nomearquivo', valor: vself.imgparaupload.name }
                ];

                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/uploadfile.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)) {
                        vself.$toastr.s('Imagem carregada com sucesso!', 'Informação!');
                        vself.mtdcarregamidia();
                    } else {
                        vself.mtdcarregamidia();
                        vself.$toastr.e('Ocorreu um erro ao carregar a imagem: ' + response.data.inf, 'Erro!');
                    }
                    })
                .catch(function (response) {
                    loader.hide();
                    vself.mtdcarregamidia();
                    vself.$toastr.e('Descrição do erro: ' + response.message, 'Erro!');
                });
                vself.mtdcancelaselecaoimagem();
            },
            mtdcarregamidia(pathimagens = null){
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'pathimagens',      valor  : pathimagens ?? vself.pathimagens},
                    {parametro: 'op',               valor  : 'carregaimagens'},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtemplatesmensagens.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.midiaName = response.data?.arquivo ?? null;
                    if (pathimagens) {
                        vself.urlMidiaModal = response.data?.arquivo ? (vself.$store.state.usuario.adrsrv+'/arquivos/manager/templatesmensagens/'+vself.$store.state.filialpadrao.idcliente+'/'+pathimagens+'/'+response.data.arquivo) : null;
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.midiaName = null;
                    console.log(response.message);
                    vself.$toastr.e('Erro ao carregar as imagens. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdconfirmaremoverimagem(){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a remoção da imagem?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'red',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-red',
                            action: function () {
                                vself.mtdremoverimagem();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });
            },
            mtdremoverimagem(){
                let vself       = this;
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'deletararquivo'},
                    {parametro: 'pastaarquivo', valor : vself.pathimagens},
                    {parametro: 'nomearquivo',  valor : vself.midiaName},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtemplatesmensagens.php');
                retorno.then(function (response) {
                    console.log(response.data);
                    loader.hide();
                    if (response.data.inf == 1){
                        vself.$toastr.s('A imagem foi removida!', 'Informação!');
                    }else{
                        vself.$toastr.e(response.data.inf, 'Erro!')
                    }
                    vself.mtdcarregamidia()
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    vself.mtdcarregamidia()
                });
            },
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('001Z.230Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' || this.vtextomsg == '' || this.vidfilial == null;
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregatemplates(val);
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    #btclonarperfilusuario{
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario:hover{
        color: #666666;
        transition: .35s;
    }

    #btmarcartodfiliais{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodfiliais:hover{
        color: #666666;
        transition: .35s;
    }
    #btclonarperfilusuario:hover{
        color: #666666;
        transition: .35s;
    }

    .btn-preview-msg{
        width: 100%;
        background-color: #00000010 !important;
        color: black !important;
        border: 2px solid rgb(204, 204, 204) !important;
        border-radius: 5px;
        padding: 5px 10px;
        margin-top: 10px;
    }
    .btn-preview-msg:focus{
        box-shadow: none !important;
    }

    .txtarea-preview-msg{
        width: 100% !important; 
        height: 500px !important; 
        font-family: 'Roboto', sans-serif !important; 
        font-size: 16px !important; 
        padding: 15px 20px !important; 
        line-height: 1.6 !important; 
        border-radius: 10px !important; 
        border: 1px solid #ced4da !important; 
        resize: none !important;
        background-color: #f9f9f9 !important;
    }
    .ct-selecaoimagem{
        padding-block: 5px 15px;
    }
</style>